import { errorSubject } from '../utilities/error-observable';

// N.B. If overrideError is true, then the caller will need to handle the error, it will not be passed to the error subject!

export async function fetchData(input: RequestInfo | URL, init?: RequestInit, overrideError?: boolean): Promise<Response> {
    try {
        /*
            Never for a multipart body: only the browser can write that header, because only the browser
            knows the boundary it generated. Stamping application/json over a FormData body is a 415 from
            the server every time.

            This is why every other file upload in the app reaches past this wrapper - the single point of
            interest attachment and the model preview image both call `fetch` directly, and the
            organisation resource upload uses XMLHttpRequest. The batch attachment came through here and
            could therefore never have worked.
        */
        const sendsFormData = init?.body instanceof FormData;

        // add the content type to the headers if the method is POST or PUT
        if (!sendsFormData && (init?.method === 'POST' || init?.method === 'PUT' || init?.method === 'PATCH')) {
            init.headers = { ...init.headers, 'Content-Type': 'application/json' };
        }

        const response = await fetch(input, init);

        // catch these errors and let the app decide what to do with them.
        if ([403, 404, 412, 500, 502].includes(response.status) && !overrideError) {
            errorSubject.next({
                ok: response.ok,
                status: response.status,
                statusText: response.statusText,
                url: response.url,
                headers: response.headers,
                type: response.type
            });
            return response;
        }

        return response;
    } catch (error: unknown) {
        errorSubject.next(error as Partial<Response>);
        throw error; // still throw the error in case anything further up is expecting an exception.
    }
}
